module.exports = __webpack_public_path__ + "static/media/team3.050a0919.jpg";